const SCHEDULE_LABELS = {
  all_week: { short: "All wk", full: "All Week", color: "bg-emerald-500 text-white" },
  mon_wed: { short: "Mon–Wed", full: "Mon–Wed", color: "bg-sky-500 text-white" },
  wed_fri: { short: "Wed–Fri", full: "Wed–Fri", color: "bg-amber-500 text-white" },
};

/**
 * ScheduleTag — pill showing delivery window.
 *
 * @param {"admin"|"card"} variant  admin = small subtle pill; card = bold top-of-card badge
 */
export function ScheduleTag({ value, variant = "admin", className = "" }) {
  const key = value || "all_week";
  const meta = SCHEDULE_LABELS[key] || SCHEDULE_LABELS.all_week;

  if (variant === "card") {
    return (
      <span
        className={`inline-flex items-center text-[11px] sm:text-xs px-2 py-0.5 sm:py-1 rounded-full font-bold uppercase tracking-wide shadow-sm ${meta.color} ${className}`}
        title={`Delivery: ${meta.full}`}
        data-testid={`schedule-tag-${key}`}
      >
        {meta.full}
      </span>
    );
  }

  // Default: subtle admin variant
  const subtleColor =
    key === "all_week"
      ? "bg-emerald-100 text-emerald-700"
      : key === "mon_wed"
      ? "bg-sky-100 text-sky-700"
      : "bg-amber-100 text-amber-700";
  return (
    <span
      className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${subtleColor} ${className}`}
      title={`Delivery: ${meta.full}`}
      data-testid={`schedule-tag-${key}`}
    >
      {meta.short}
    </span>
  );
}
